import { createAsyncThunk } from "@reduxjs/toolkit";
import { type BenefitNotification } from "../../../domain/entities/first-purchase";
import { type NotifyBenefitParams } from "../../../domain/repos/first-purchase-repo";
import { type FirstPurchaseDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const notifyBenefit = createAsyncThunk<
  BenefitNotification,
  NotifyBenefitParams,
  { dispatch: FirstPurchaseDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.NOTIFY_BENEFIT, async (params, { extra }) => {
  return await extra.firstPurchaseRepo.notifyBenefit(params);
});
